import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './modules/rootReducer';
import rootSaga from './modules/rootSaga';
import { themeMiddleware, applyInitialTheme } from './middleware/themeMiddleware';

const sagaMiddleware = createSagaMiddleware();

import { batchedSubscribe } from 'redux-batched-subscribe';
import { unstable_batchedUpdates } from 'react-dom';
import { sentryWebSocketMiddleware } from './middleware/sentryWebSocketMiddleware';

const enhancer = composeWithDevTools(
  applyMiddleware(sagaMiddleware, themeMiddleware, sentryWebSocketMiddleware),
  batchedSubscribe(unstable_batchedUpdates)
)

const store = createStore(
  rootReducer,
  enhancer
);

sagaMiddleware.run(rootSaga);

applyInitialTheme(store);

export default store;
